import styled from 'styled-components';

export const CardTitle = styled.div`
  display: flex;    
  font-size: 16px;
  padding: 24px 24px 12px 24px;
  font-weight: 500;
`;